'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _BaseMenu = require('./BaseMenu');

var _BaseMenu2 = _interopRequireDefault(_BaseMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BaseMenu2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/BaseMenu/index.js
// module id = 162
// module chunks = 11